import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, TemplateRef } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { BannerComponent } from '../../banner/banner.component';
import { Icon, IconComponent } from '../../icon';
import { TooltipDirective } from '../../tooltip/tooltip.directive';

@Component({
  selector: 'smw-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.less'],
  imports: [TranslateModule, NgTemplateOutlet, TooltipDirective, BannerComponent, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionComponent {
  title = input.required<string>();
  tooltip = input.required<string | TemplateRef<unknown>>();
  bannerContent = input<TemplateRef<unknown> | undefined>();

  tooltipIcon = Icon.question;
}
